module.exports = __webpack_public_path__ + "static/media/peyzan.f3cc7929.png";